import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelectedDateStore } from '../../../features/calendar/CalendarStore';

/**
 * @typedef {object} CalendarPageRedirectorData
 * @property {string} [eventDate]
 */

/**
 * @typedef {object} CalendarPageRedirectorProps
 * @property {CalendarPageRedirectorData} [data]
 */

/**
 * @param {CalendarPageRedirectorProps} props
 */
const CalendarPageRedirector = props => {
  const { data } = props;

  const setSelectedDate = useSelectedDateStore.getState().setSelectedDate;

  const parsedDate = new Date(data.eventDate);
  const dateToUse = !isNaN(parsedDate.getTime()) ? parsedDate : new Date();
  setSelectedDate(dateToUse);

  return <Navigate to='/calendar' replace />;
};

export default CalendarPageRedirector;
